<template lang="pug">

.cabinets-page
  .content-container
    v-card.cabinets-card
      v-card-title.cabinets-title {{ isSchool ? 'Кабинеты' : 'Аудитории' }}

      v-card-text.pa-6
        .cabinets-list
          router-link.cabinet-link(
            v-for="cabinet in cabinetsOrdered"
            :key="cabinet.id"
            :to="{ name: 'cabinets_lessons', params: { cabinetId: cabinet.id }}"
          ) {{ cabinet.label }}

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'Cabinets',

  async beforeRouteEnter(to, from, next) {
    await store.dispatch('dictionaries/fetchCabinets')

    store.commit('breadcrumbs/update', [{ text: store.getters['bootstrap/isSchool'] ? 'Кабинеты' : 'Аудитории' }])
    next()
  },

  computed: {
    ...mapState('dictionaries', ['cabinets']),
    ...mapGetters('bootstrap', ['isSchool']),

    cabinetsOrdered() {
      return this.cabinets
        .map((x) => ({ ...x, label: `${x.shortName ? `${x.shortName} - ` : ''}${x.name}` }))
        .sort((a, b) => a.label.localeCompare(b.label))
    }
  },

  methods: {
    getCabinet(item) {
      return item.name
    }
  },
}
</script>

<style lang="sass" scoped>

.cabinets-page
  padding-bottom: 40px

.content-container
  max-width: 1200px
  margin: 0 auto
  padding: 0 24px

.cabinets-card
  background: white
  box-shadow: 0 2px 8px rgba(0,0,0,0.1)
  border: 1px solid #e2e8f0
  margin-top: 20px

.cabinets-title
  color: #1e293b
  font-size: 1.5rem
  font-weight: 600
  padding: 24px 24px 0
  border-bottom: 1px solid #f1f5f9

.cabinets-list
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr))
  gap: 12px

.cabinet-link
  display: flex
  align-items: center
  min-height: 40px
  text-decoration: none
  color: #3b82f6
  font-size: 14px
  padding: 8px 12px
  border-radius: 8px
  border: 1px solid #e2e8f0
  background: #f8fafc
  transition: all 0.2s ease
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  // Hover only for devices with mouse
  @media (hover: hover)
    &:hover
      background: rgba(59, 130, 246, 0.1)
      border-color: #3b82f6
      text-decoration: none
      color: #1e40af
      transform: translateY(-1px)
      box-shadow: 0 2px 8px rgba(0,0,0,0.1)

  // Active state for touch devices
  &:active
    background: rgba(59, 130, 246, 0.15)
    transform: scale(0.98)

// Responsive breakpoints
@media (max-width: 1200px)
  .cabinets-list
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr))

@media (max-width: 1100px)
  .cabinets-list
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr))

@media (max-width: 900px)
  .cabinets-list
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))

@media (max-width: 768px)
  .cabinets-page
    padding: 16px

  .content-container
    padding: 0 16px

  .cabinets-title
    font-size: 1.25rem
    padding: 20px 20px 0

  .cabinets-list
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr))
    gap: 10px

@media (max-width: 480px)
  .cabinets-page
    padding: 12px

  .content-container
    padding: 0 20px

  .cabinets-title
    font-size: 1.1rem
    padding: 16px 16px 0

  .cabinets-list
    grid-template-columns: 1fr
    gap: 8px

  .cabinet-link
    font-size: 13px
    min-height: 36px
    padding: 6px 10px

@media (max-width: 360px)
  .cabinet-link
    font-size: 12px
    padding: 6px 8px
</style>
